import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`

* {
  font-family: 'pretendard';
  box-sizing: border-box;
}

html,body{
    width:100%;
    height:100%;
    min-height:100vh;
    background-color: #ffffff;
}

:root{
  line-height:0;
  overflow-x: hidden;
}

html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,input,button,
dl, dt, dd, menu, ol, ul, li,
fieldset, form, label, legend,
table, caption, 
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
main, menu, nav, output, ruby, section, summary,
time, mark, audio, video,tbody, tfoot, thead, tr, th, td { 
  margin: 0;
  padding: 0;
  border: 0;
  vertical-align: baseline;
  -webkit-tap-highlight-color: transparent;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

ol, ul{
    list-style: none;
}

button {
    background-color: transparent;
    cursor: pointer;
}

textarea:focus,input:focus {
    outline: none;
}


a{
  display:inline-block;
}

a,a:hover, a:active {
    color: inherit;
    text-decoration: none;
}


input::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
} 
input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus, 
input:-webkit-autofill:active  {
    transition: background-color 5000s;
    -webkit-text-fill-color: transparent !important;
}

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 3px;
    height: 3px;
  }

  &::-webkit-scrollbar-thumb {
    border-radius:10px;
    background-color:${({ theme }) => theme.colors.primary};
  }
.is-invalid{
  border: 1px solid red;
}
.error{
  color: red;
  padding-top: 5px;
}
`;
